const initialState = ""

const operationTypeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_OPERATION_TYPE":
      return action?.operation_type
      break
    default:
      return state
  }
}

export default operationTypeReducer